import { ScholarshipCard, ScholarshipsResult, StateSpotlightEligibility, usheIds } from '@common-types';
import { baseService } from '@services/base.service';

import { StateSpotlight } from '@interfaces/stateSpotlight';

const UTAH_STATE_SPOTLIGHT: Omit<StateSpotlight, 'isEnabled'> = {
  stateCode: 'UT',
  stateName: 'Utah',
  publicCollegeIds: usheIds,
};

export const getStateSpotlight = async (): Promise<StateSpotlight> => {
  const { isEligible } = await baseService.getAsync<StateSpotlightEligibility>('/user/state-spotlight');

  return { ...UTAH_STATE_SPOTLIGHT, isEnabled: isEligible };
};

const getUtahBadge = ({ isUshe, isUtah }: ScholarshipCard): ScholarshipCard['utahBadge'] => {
  if (isUshe) return 'ushe';
  if (isUtah) return 'utah';

  return undefined;
};

export const withUtahBadges = (result: ScholarshipsResult): ScholarshipsResult => {
  if (!result?.scholarships) return result;

  return {
    ...result,
    scholarships: result.scholarships.map((scholarship) => ({
      ...scholarship,
      utahBadge: scholarship.utahBadge ?? getUtahBadge(scholarship),
    })),
  };
};
